import * as React from 'react';
import { connect } from 'react-redux';
import { assign } from '../../shared/Assign';
import { handleError } from '../../shared/ErrorCatching';
import { Translate } from '../../shared/LanguageService';
import { Modal, Button } from 'react-bootstrap';
import ProductTypeForm from './ProductTypeForm';
import IProductType from './IProductType';
import * as Actions from './Actions';
import notify from '../../shared/feedback/notifications';

export class ProductTypeModal extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            input: assign({}, this.props.emptyInput),
            errors: {},
            creating: false,
            types: [],
            productTypeType: ''
        };

        this.onFormInputChange = this.onFormInputChange.bind(this);
        this.save = this.save.bind(this);
        this.create = this.create.bind(this);
        this.update = this.update.bind(this);
    }

    UNSAFE_componentWillMount(): void {
        if (this.props.editId > 0) {
            this.props.actions
                .edit(this.props.editId)
                .then(() => {
                    this.setState({
                        input: assign({}, this.props.edit),
                        types: assign([], this.props.edit.types)
                    });
                })
                .catch((error: any) =>
                    handleError(error, (errors: any): void => {
                        this.setState({ errors: errors });
                    })
                );
        } else {
            this.props.actions
                .new()
                .then(() => {
                    this.setState({ types: assign([], this.props.new.types) });
                })
                .catch(handleError);
        }
    }

    onFormInputChange(e: any): void {
        let input = this.state.input;
        const value = e.target.value;

        input[e.target.name] = value;
        this.setState({ input: assign({}, input) });
    }

    save(e: React.FormEvent): void {
        e.preventDefault();
        this.setState({ creating: true });
        if (this.props.editId > 0) {
            this.update();
        } else {
            this.create();
        }
    }

    create(): void {
        this.props.actions
            .create(this.state.input)
            .then(() => {
                this.setState({ creating: false });
                this.props.closeModal();
                notify.success(Translate('product-types/notification/product-type-added'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    update(): void {
        this.props.actions
            .update(this.state.input)
            .then(() => {
                this.setState({ creating: false });
                this.props.closeModal();
                notify.success(Translate('product-types/notification/product-type-updated'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    render(): any {
        return (
            <Modal show={this.props.shouldShowModal} onHide={this.props.closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.props.editId > 0
                            ? Translate('product-types/modal/title/edit-product-type')
                            : Translate('product-types/modal/title/add-product-type')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ProductTypeForm
                        name={this.state.input.name}
                        onChange={this.onFormInputChange}
                        errors={this.state.errors}
                        productTypeType={this.state.input.productTypeType}
                        types={this.state.types}
                        save={this.save}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.closeModal}>
                        {Translate('product-types/modal/footer/button-label/close')}
                    </Button>
                    <Button disabled={this.state.creating} bsStyle="primary" onClick={this.save}>
                        {Translate('product-types/modal/footer/button-label/save')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        emptyInput: { id: -1, name: '', productTypeType: '' },
        edit: state.productTypes.edit,
        new: state.productTypes.new
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            new: () => dispatch(Actions.getNew()),
            create: (input: IProductType) => dispatch(Actions.create(input)),
            edit: (id: number) => dispatch(Actions.edit(id)),
            update: (input: IProductType) => dispatch(Actions.update(input))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductTypeModal);
